import { buildSelector } from '@/shared/lib/store';

export const [useGetTradingPlatformSessionId] = buildSelector(
    (state) => state.tradingPlatformSession.accountId,
);
